export const antispamAutoCompleteKey = 'autocomplete-off-field';
